import React from "react";
import * as styles from "./Icon.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

export const availableIcons = [
	"add",
	"arrow-down",
	"arrow-left",
	"arrow-right",
	"arrow-up",
	"arrow",
	"bin",
	"calendar-alt",
	"calendar",
	"check-circle",
	"check",
	"chevron-circle-left",
	"chevron-circle-right",
	"circle-info-fill",
	"circle-info",
	"close-circle-fill",
	"close-circle",
	"close",
	"copy",
	"edit",
	"filter",
	"id-card",
	"no-wlan",
	"pen",
	"save",
	"sort",
	"star-fill",
	"star",
	"user-talk",
	"user",
	"warning",
	"warning-lines",
	"warning-lines-regular",
	"x-circle",
];

const Icon = ({ icon, size, className, ...rest }) => {
	const iconClassName = classNames({
		[styles["icon"]]: true,
		[`icon icon--${icon}`]: icon,
		[styles[`icon--size-${size}`]]: size,
		[className]: !!className,
	});

	return <i className={iconClassName} {...rest}></i>;
};

Icon.propTypes = {
	icon: PropTypes.oneOf(availableIcons).isRequired,
	size: PropTypes.oneOf([10, 12, 14, 16, 18, 20, 24, 30, 36, 42, 48, 64, 160]),
	className: PropTypes.string,
};

export default Icon;
